import { LOCATION_AREA_ENUM } from '../enums/LocationAreas';
import countries from '@shared/consts/countries';
import { normalizeCountry } from '@shared/helpers/normalizeCountry';

export function findLocationArea(country: string) {
  const findedCountry = countries.find((c) => normalizeCountry(country) === c.label);
  return !findedCountry?.continent
    ? null
    : ['AS', 'EU'].includes(findedCountry?.continent)
    ? LOCATION_AREA_ENUM.EURASIA
    : ['NA', 'SA'].includes(findedCountry?.continent)
    ? LOCATION_AREA_ENUM.AMERICAS
    : null;
}
